import BaseModelAPI from '../BaseModelAPI';

export default class ReminderStatus extends BaseModelAPI {
	static entity = 'reminderstatus';
	static entityName = 'reminderstatus';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.createdBy = '';
			this.updatedBy = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}